import { css, cx } from '@emotion/css';

const cn = {
  fullHeightContainer: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
};

interface FullHeightContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const FullHeightContainer: React.FC<FullHeightContainerProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={cx(cn.fullHeightContainer, className)} {...props}>
      {children}
    </div>
  );
};

FullHeightContainer.displayName = 'FullHeightContainer';
